import React from 'react';
import Loader from 'react-loader-spinner';
import cx from 'classnames';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const Spinner = ({ position, bg }) => {
    const spinnerClass = cx(
        'sign__loader',
        {
            [`sign__loader--${position}`]: position,
        },
        {
            [`sign__loader--${bg}`]: bg,
        },
    );
    return (
        <div className={spinnerClass}>
            <Loader type="TailSpin" color="#0054a6" secondaryColor="#ededed" height={80} width={80} />
        </div>
    );
};

export default Spinner;
